import React from 'react';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import Markdown from '@/pages/Dev/components/Markdown';
import { doBuried } from '@/services/buriedService';

export default function Code({ brokerServiceUrl }) {
  const content1 = `
  1.下载任意一个 Deb 软件包：
  ~~~bash~DEV_CPP_DEB_1_COPY
  # 该软件包包含共享库 libpulsar.so 和 libpulsarnossl.so。
  wget https://archive.apache.org/dist/pulsar/pulsar-client-cpp-3.4.2/deb-x86_64/apache-pulsar-client.deb
  # 该软件包包含共享库 libpulsar.a, libpulsarwithdeps.a 和 C/C++ headers.
  wget https://archive.apache.org/dist/pulsar/pulsar-client-cpp-3.4.2/deb-x86_64/apache-pulsar-client-dev.deb
  ~~~
  2.安装软件包
  ~~~bash~DEV_CPP_DEB_2_COPY
  apt install ./apache-pulsar-client*.deb
  ~~~
  `;
  const content2 = `
  1.下载任意一个 rpm 软件包：
  ~~~bash~DEV_CPP_RPM_1_COPY
  #该软件包包含共享库：libpulsar.so 和 libpulsarnossl.so。
  wget https://archive.apache.org/dist/pulsar/pulsar-client-cpp-3.4.2/rpm-x86_64/x86_64/apache-pulsar-client-3.4.2-1.x86_64.rpm
  #该软件包包含 libpulsar.so 的debug symbols。
  wget https://archive.apache.org/dist/pulsar/pulsar-client-cpp-3.4.2/rpm-x86_64/x86_64/apache-pulsar-client-debuginfo-3.4.2-1.x86_64.rpm
  # 该软件包包含共享库 libpulsar.a, libpulsarwithdeps.a 和 C/C++ headers.
  wget https://archive.apache.org/dist/pulsar/pulsar-client-cpp-3.4.2/rpm-x86_64/x86_64/apache-pulsar-client-devel-3.4.2-1.x86_64.rpm
  ~~~
  2.安装软件包
  ~~~bash~DEV_CPP_RPM_2_COPY
  rpm -ivh apache-pulsar-client*.rpm
  ~~~
  `;
  const content3 = `
  ~~~c++~DEV_CPP_PRODUCER_COPY
  #include <pulsar/Client.h>
  #include <thread>
  #include <atomic>
  
  using namespace pulsar;
  
  std::atomic<uint32_t> acksReceived;
  
  void callback(Result code, const MessageId& msgId, std::string msgContent) {
      // 消息处理逻辑
      std::cout << "Received ack for msg: " << msgContent << " with code: "
          << code << " -- MsgID: " << msgId << std::endl;
      acksReceived++;
  }
  
  int main() {
      Client client("${brokerServiceUrl}");
  
      ProducerConfiguration producerConf;
      producerConf.setBlockIfQueueFull(true);
      Producer producer;
      Result result = client.createProducer("persistent://public/default/test",
                                            producerConf, producer);
      if (result != ResultOk) {
          std::cout << "Error creating producer: " << result << std::endl;
          return -1;
      }
  
      // 异步发送100条消息
      int ctr = 0;
      while (ctr < 100) {
          std::string content = "msg" + std::to_string(ctr);
          Message msg = MessageBuilder().setContent(content).setProperty("x", "1").build();
          producer.sendAsync(msg, std::bind(callback,
                                            std::placeholders::_1, std::placeholders::_2, content));
  
          std::this_thread::sleep_for(std::chrono::milliseconds(100));
          ctr++;
      }
  
      // 等待 100 条消息被确认
      while (acksReceived < 100) {
          std::this_thread::sleep_for(std::chrono::milliseconds(100));
      }
  
      std::cout << "Finished producing asynchronously!" << std::endl;
  
      client.close();
      return 0;
  }
  ~~~
  `;
  const content4 = `
  ~~~c++~DEV_CPP_CONSUMER_COPY
  #include <pulsar/Client.h>

  using namespace pulsar;
  
  int main() {
      Client client("${brokerServiceUrl}");
      
      Consumer consumer;
      ConsumerConfiguration config;
      config.setSubscriptionInitialPosition(InitialPositionEarliest);
      Result result = client.subscribe("persistent://public/default/test", "consumer-1", config, consumer);
      if (result != ResultOk) {
          std::cout << "Failed to subscribe: " << result << std::endl;
          return -1;
      }
  
      Message msg;
      int ctr = 0;
      // 消费100条消息
      while (ctr < 100) {
          consumer.receive(msg);
          std::cout << "Received: " << msg
              << "  with payload '" << msg.getDataAsString() << "'" << std::endl;
  
          consumer.acknowledge(msg);
          ctr++;
      }
  
      std::cout << "Finished consuming synchronously!" << std::endl;
  
      client.close();
      return 0;
  }
  ~~~
  `;
  return (
    <Tabs defaultValue='DEV_CPP_DEB' onChange={(val) => doBuried({ eventId: val })}>
      <TabPanel value='DEV_CPP_DEB' label='Deb'>
        <Markdown content={content1} />
      </TabPanel>
      <TabPanel value='DEV_CPP_RPM' label='RPM'>
        <Markdown content={content2} />
      </TabPanel>
      <TabPanel value='DEV_CPP_PRODUCER' label='Producer'>
        <Markdown content={content3} />
      </TabPanel>
      <TabPanel value='DEV_CPP_CONSUMER' label='Consumer'>
        <Markdown content={content4} />
      </TabPanel>
    </Tabs>
  );
}
